import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 状态
 */
class State extends UltMeta {
    EFFECTIVE = new Meta(1, "已生效");
    INVALID = new Meta(2, "已失效", "color-info");
}
export const STATE = new State();
